<template>
    <div>
        <v-container>
            <v-row>
                <v-col><h1>{{asset.name}}</h1></v-col>
                <v-col cols="2"><v-btn color="decline" height="30" tile block @click="showNoService = true">Felanmäl</v-btn></v-col>
                <v-col cols="2"><v-btn color="addStuff" height="30" tile block @click="clickBack()">Tillbaka</v-btn></v-col>
            </v-row>
            <v-row>
                <v-col>{{ labels }}</v-col>
                <v-col v-if="showNoService" class="no-service">Denna är inte kopplad till Serviceavtal. Kontakta Perfecta Storkök för hjälp</v-col>
            </v-row>
        </v-container>
        <v-container class="details-container">
            <v-row>
                <v-col class="label">Objektnummer</v-col>
                <v-col>{{ asset.assetNo }}</v-col>
                <v-spacer></v-spacer>
                <v-col class="label">Objekttyp</v-col>
                <v-col>{{ asset.assetTypeName }}</v-col>
            </v-row>
            <v-row>
                <v-col class="label">Plats</v-col>
                <v-col>{{ address }}</v-col>
                <v-spacer></v-spacer>
                <v-col class="label">Status</v-col>
                <v-col>{{ state }}</v-col>
            </v-row>
            <template v-for="(field,index) in asset.customFields">
                <v-row v-if="index % 2 == 0" :key="index">
                    <v-col class="label">{{ field.label }}</v-col>
                    <v-col>{{ field.value }}</v-col>
                    <v-spacer></v-spacer>
                    <template v-if="asset.customFields[index+1]">
                        <v-col class="label">{{ asset.customFields[index+1].label }}</v-col>
                        <v-col>{{ asset.customFields[index+1].value }}</v-col>
                    </template>
                    <template v-else>
                        <v-col class="label"></v-col>
                        <v-col></v-col>
                    </template>
                </v-row>
            </template>
        </v-container>
    </div>
</template>

<script>
export default {
    'name': 'AssetDetails',
    props: ['asset'],
    mounted() {

    },
    data: () => ({
        showNoService: false
    }),
    methods: {
        clickBack() {
            this.$router.go(-1);
        }
    },
    computed: {
        state() {
            return this.asset.state == 'OUT_OF_ORDER' ? 'Ur funktion' : 'I drift';
        },
        address() {
            return this.asset.location && this.asset.location.placeName;
        },
        labels() {
            return this.asset.labels && this.asset.labels.join(', ');
        }
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
    .label {
        color: grey;
        text-align: right;
    }
    .no-service {
        color: darkred;
        text-align: right;
        font-weight: bold;
    }
</style>